// import React, { useEffect } from 'react';
// import { RxCross1 } from 'react-icons/rx';
// import { HiLocationMarker } from 'react-icons/hi';
// import { MdDirectionsCar } from 'react-icons/md';
// import { IoSparkles } from 'react-icons/io5';
// import { RiCoupon3Line } from 'react-icons/ri';
// import { formatDate, formatTimeInTimezone } from 'pages/utils/formdatedynamics';
// import './PopupInvoice.css';

// function PopupInvoice({ isOpen, onClose, data }) {

//   useEffect(() => {
//     const handleClickOutside = (e) => {
//       if (e.target.classList.contains('pi-overlay')) onClose();
//     };
//     if (isOpen) document.addEventListener('click', handleClickOutside);
//     return () => document.removeEventListener('click', handleClickOutside);
//   }, [isOpen, onClose]);

//   if (!data) return null;

//   const toNumber = (value) => {
//     const parsed = Number(value);
//     return Number.isFinite(parsed) ? parsed : 0;
//   };

//   // ─── Base values ───────────────────────────────────────────────
//   const cost           = toNumber(data.cost);           // shop price
//   const basePrice      = toNumber(data.serviceVariant?.basePrice) || cost;
//   const addOnsTotal    = toNumber(data.addOnsTotal || data.orderDetails?.addOnsTotal);

//   // ─── Washta Fee ────────────────────────────────────────────────
//   // fee comes as "5%" string — parse the number out
//   const feePercent     = toNumber(data.fee);            // e.g. 5
//   const washtaFee      = parseFloat(((cost * feePercent) / 100).toFixed(2));

//   // ─── Promo Code ────────────────────────────────────────────────
//   const promoCode      = data.promoCode;
//   const totalDiscount  = toNumber(data.discount);       // total discount already on order

//   // 50/50 split between seller and washta
//   const sellerPromoShare  = promoCode ? parseFloat((totalDiscount / 2).toFixed(2)) : 0;
//   const washtaPromoShare  = promoCode ? parseFloat((totalDiscount / 2).toFixed(2)) : 0;

//   // ─── Seller receives ───────────────────────────────────────────
//   // cost - washta fee - seller's half of promo discount
//   const sellerReceives = parseFloat((cost - washtaFee - sellerPromoShare + addOnsTotal).toFixed(2));

//   // ─── Washta pays (promo share only — fee is income for washta) ─
//   const washtaPays     = washtaPromoShare;

//   // ─── Helpers ──────────────────────────────────────────────────
//   const formatOrderId = (item) => {
//     if (!item?._id || !item?.date) return item?._id || '—';
//     const year    = new Date(item.date).getFullYear();
//     const lastSix = item._id.slice(-6).toUpperCase();
//     return `WAS-${year}-${lastSix}`;
//   };

//   const vehicle = data.vehicleId;
//   const vehicleLabel = vehicle
//     ? `${vehicle.vehicleManufacturer} ${vehicle.vehicleName} · ${vehicle.vehiclePlateNumber}`
//     : '—';

//   const cap = (str) => str ? str.charAt(0).toUpperCase() + str.slice(1) : '—';

//   const paidDate = data.paidAt
//     ? `${formatDate(data.paidAt)} · ${formatTimeInTimezone(data.paidAt)}`
//     : '—';

//   return (
//     <div className={`pi-overlay ${isOpen ? 'pi-open' : 'pi-close'}`}>
//       <div className={`pi-modal ${isOpen ? 'pi-slide-in' : 'pi-slide-out'}`}>

//         {/* ── Header ── */}
//         <div className="pi-header">
//           <div className="pi-header-top">
//             <div>
//               <p className="pi-label-sm">Invoice</p>
//               <p className="pi-order-id">{formatOrderId(data)}</p>
//             </div>
//             <div className="pi-header-actions">
//               <span className={`pi-badge pi-status-${data.status}`}>{cap(data.status)}</span>
//               <RxCross1 className="pi-close-icon" onClick={onClose} />
//             </div>
//           </div>
//           <div className="pi-header-meta">
//             <div>
//               <p className="pi-meta-label">Date</p>
//               <p className="pi-meta-value">{paidDate}</p>
//             </div>
//             <div>
//               <p className="pi-meta-label">Billing</p>
//               <p className="pi-meta-value">{cap(data.billingStatus)}</p>
//             </div>
//           </div>
//         </div>

//         {/* ── Body ── */}
//         <div className="pi-body">

//           {/* Location + Vehicle */}
//           <div className="pi-info-grid">
//             <div className="pi-info-card">
//               <p className="pi-info-label">
//                 <HiLocationMarker className="pi-info-icon" />
//                 Location
//               </p>
//               <p className="pi-info-value">{data.location?.display_name || data.location?.text || '—'}</p>
//             </div>
//             <div className="pi-info-card">
//               <p className="pi-info-label">
//                 <MdDirectionsCar className="pi-info-icon" />
//                 Vehicle
//               </p>
//               <p className="pi-info-value">{vehicleLabel}</p>
//             </div>
//           </div>

//           {/* Service */}
//           <div className="pi-service-card">
//             <p className="pi-info-label">
//               <IoSparkles className="pi-info-icon" />
//               Service
//             </p>
//             <div className="pi-service-row">
//               <p className="pi-info-value">{data.orderDetails?.service || '—'}</p>
//               {data.serviceVariant?.variantTypeLabel && (
//                 <span className="pi-variant-badge">
//                   {data.serviceVariant.variantTypeLabel}
//                 </span>
//               )}
//             </div>
//           </div>

//           {/* ── Price Breakdown ── */}
//           <div className="pi-breakdown">
//             <p className="pi-breakdown-title">Price breakdown</p>

//             {/* Shop price */}
//             <div className="pi-line-item">
//               <span className="pi-line-label">Price</span>
//               <span className="pi-line-value">{cost.toFixed(2)} AED</span>
//             </div>

//             {addOnsTotal > 0 && (
//               <div className="pi-line-item">
//                 <span className="pi-line-label">Add-ons</span>
//                 <span className="pi-line-value">{addOnsTotal.toFixed(2)} AED</span>
//               </div>
//             )}

//             {/* Washta fee */}
//             <div className="pi-line-item">
//               <span className="pi-line-label pi-fee-label">
//                 Washta fee ({feePercent}%)
//               </span>
//               <span className="pi-line-value pi-fee-value">− {washtaFee.toFixed(2)} AED</span>
//             </div>

//             {/* Promo code — only if applied */}
//             {promoCode && totalDiscount > 0 && (
//               <>
//                 <div className="pi-promo-section">
//                   <div className="pi-promo-header">
//                     <RiCoupon3Line className="pi-coupon-icon" />
//                     <span className="pi-promo-name">
//                       {promoCode.promoCode} &nbsp;
//                       <span className="pi-promo-tag">
//                         {promoCode.discount}{promoCode.Discounttype === 'percentage' ? '%' : ' AED'} off
//                       </span>
//                     </span>
//                     <span className="pi-promo-total">− {totalDiscount.toFixed(2)} AED</span>
//                   </div>
//                   <div className="pi-promo-split">
//                     <div className="pi-split-row">
//                       <span>Your share (50%)</span>
//                       <span>− {sellerPromoShare.toFixed(2)} AED</span>
//                     </div>
//                     <div className="pi-split-divider" />
//                     <div className="pi-split-row pi-washta-share">
//                       <span>Washta pays (50%)</span>
//                       <span>− {washtaPromoShare.toFixed(2)} AED</span>
//                     </div>
//                   </div>
//                 </div>
//               </>
//             )}

//             <div className="pi-dashed-divider" />

//             {/* Seller receives */}
//             <div className="pi-total-row">
//               <span className="pi-total-label">You receive</span>
//               <span className="pi-total-value">{sellerReceives.toFixed(2)} AED</span>
//             </div>

//             {/* Washta pays note */}
//             {promoCode && washtaPays > 0 && (
//               <div className="pi-washta-note">
//                 <span>Washta pays</span>
//                 <span className="pi-washta-pays">{washtaPays.toFixed(2)} AED</span>
//               </div>
//             )}
//           </div>

//         </div>
//       </div>
//     </div>
//   );
// }

// export default PopupInvoice;
import React, { useEffect } from 'react';
import { RxCross1 } from 'react-icons/rx';
import { HiLocationMarker } from 'react-icons/hi';
import { MdDirectionsCar } from 'react-icons/md';
import { IoSparkles } from 'react-icons/io5';
import { MdLocalParking } from 'react-icons/md';
import { formatDate, formatTimeInTimezone } from 'pages/utils/formdatedynamics';
import './PopupInvoice.css';

function PopupInvoice({ isOpen, onClose, data }) {

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (e.target.classList.contains('pi-overlay')) onClose();
    };
    if (isOpen) document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, [isOpen, onClose]);

  if (!data) return null;

  const toNumber = (value) => {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : 0;
  };

  // ─── Base values ───────────────────────────────────────────────
  const cost        = toNumber(data.cost);   // original standard service price (pre-discount)
  const addOnsTotal = toNumber(data.addOnsTotal || data.orderDetails?.addOnsTotal);
  const WASHTA_FEE_PERCENT   = 0;
  const washtaFee = parseFloat(((cost * WASHTA_FEE_PERCENT) / 100).toFixed(2));
  const promoCode     = data.promoCode;
  const totalDiscount = toNumber(data.discount);
  const sellerReceives = parseFloat(
    (cost - washtaFee + addOnsTotal).toFixed(2)
  );

  // ─── Helpers ──────────────────────────────────────────────────
 const formatOrderId = (item) => {
  if (!item?._id) return "";
  const orderId = `${item._id.slice(0, 4)}${item._id.slice(-4)}`.toUpperCase();
  return `WS-${orderId}`;
};

  const vehicle = data.vehicleId;
  const vehicleLabel = vehicle
    ? `${vehicle.vehicleManufacturer} ${vehicle.vehicleName} · ${vehicle.vehiclePlateNumber}`
    : '—';

  const cap = (str) => str ? str.charAt(0).toUpperCase() + str.slice(1) : '—';

  const paidDate = data.paidAt
    ? `${formatDate(data.paidAt)} · ${formatTimeInTimezone(data.paidAt)}`
    : '—';

    console.log('dadsadas',data.shopLocationText
)
  return (
    <div className={`pi-overlay ${isOpen ? 'pi-open' : 'pi-close'}`}>
      <div className={`pi-modal ${isOpen ? 'pi-slide-in' : 'pi-slide-out'}`}>

        {/* ── Header ── */}
        <div className="pi-header">
          <div className="pi-header-top">
            <div>
              <p className="pi-label-sm">Invoice</p>
              <p className="pi-order-id">{formatOrderId(data)}</p>
            </div>
            <div className="pi-header-actions">
              <span className={`pi-badge pi-status-${data.status}`}>{cap(data.status)}</span>
              <RxCross1 className="pi-close-icon" onClick={onClose} />
            </div>
          </div>
          <div className="pi-header-meta">
            <div>
              <p className="pi-meta-label">Date</p>
              <p className="pi-meta-value">{paidDate}</p>
            </div>
            <div>
              <p className="pi-meta-label">Billing</p>
              <p className="pi-meta-value">{cap(data.billingStatus)}</p>
            </div>
          </div>
        </div>

        {/* ── Body ── */}
        <div className="pi-body">

          {/* Location + Vehicle + Parking */}
          <div className="pi-info-grid">
            <div className="pi-info-card">
              <p className="pi-info-label">
                <HiLocationMarker className="pi-info-icon" />
                Location
              </p>
              <p className="pi-info-value">{data?.shopLocationText || data?.serviceLocation?.text || '—'}</p>
            </div>
            <div className="pi-info-card">
              <p className="pi-info-label">
                <MdDirectionsCar className="pi-info-icon" />
                Vehicle
              </p>
              <p className="pi-info-value">{vehicleLabel}</p>
            </div>
            
          </div>
{data.carParkedAt && (
              <div className="pi-service-card" style={{marginBottom:"9px"}}>
                <p className="pi-info-label">
                  <MdLocalParking className="pi-info-icon" />
                  Parking
                </p>
                <p className="pi-info-value">{data.carParkedAt}</p>
              </div>
            )}
          {/* Service */}
          <div className="pi-service-card">
            <p className="pi-info-label">
              <IoSparkles className="pi-info-icon" />
              Service
            </p>
            <div className="pi-service-row">
              <p className="pi-info-value">{data.orderDetails?.service || '—'}</p>
              {data.serviceVariant?.variantTypeLabel && (
                <span className="pi-variant-badge">
                  {data.serviceVariant.variantTypeLabel}
                </span>
              )}
            </div>
          </div>

          {/* ── Price Breakdown ── */}
          <div className="pi-breakdown">
            <p className="pi-breakdown-title">Price breakdown</p>

            {/* Shop price */}
            <div className="pi-line-item">
              <span className="pi-line-label">Price</span>
              <span className="pi-line-value">{cost.toFixed(2)} AED</span>
            </div>

            {/* Add-ons */}
            {addOnsTotal > 0 && (
              <div className="pi-line-item">
                <span className="pi-line-label">Add-ons</span>
                <span className="pi-line-value">+ {addOnsTotal.toFixed(2)} AED</span>
              </div>
            )}

            {/* Washta commission — fixed 8% of original price */}
            {/* <div className="pi-line-item">
              <span className="pi-line-label pi-fee-label">
                Washta commission ({WASHTA_FEE_PERCENT}%)
              </span>
              <span className="pi-line-value pi-fee-value">− {washtaFee.toFixed(2)} AED</span>
            </div> */}

            <div className="pi-dashed-divider" />

            {/* Amount Washta pays to seller */}
            <div className="pi-total-row">
              <span className="pi-total-label">Total</span>
              <span className="pi-total-value">{sellerReceives.toFixed(2)} AED</span>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

export default PopupInvoice;